"use client";

import clsx from "clsx";
import { useEffect, useState, memo } from "react";
import Image from "next/image";

import Button from "@/shared/components/Button";
import appleDownloadBadge from "@public/apple_download_badge.svg";
import googleDownloadBadge from "@public/google_download_badge.svg";

import { PATHS } from "@/shared/utils/paths";

import s from "./styles.module.css";

enum OS {
  ios,
  android,
  other,
  notDetermined,
}

const ANDROID_LINK = () => (
  <a className={clsx(s.link, s.google)} href={PATHS.googleplay}>
    <Image
      fill
      src={googleDownloadBadge}
      alt="Google Play branded download button"
    />
  </a>
);

const IOS_LINK = () => (
  <a className={clsx(s.link, s.apple)} href={PATHS.appstore}>
    <Image
      fill
      src={appleDownloadBadge}
      alt="App Store branded download button"
    />
  </a>
);

export const useInstallLink = () => {
  const os = useOs();
  return os === OS.android ? PATHS.googleplay : PATHS.appstore;
};

export const PlainAppStoreButton = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  const link = useInstallLink();

  return (
    <Button className={className} href={link}>
      {children}
    </Button>
  );
};

export const useOs = () => {
  const [os, setOs] = useState(OS.notDetermined);

  useEffect(() => {
    const userAgent = window.navigator.userAgent.toLowerCase(),
      // macosPlatforms = /(macintosh|macintel|macppc|mac68k|macos)/i,
      // windowsPlatforms = /(win32|win64|windows|wince)/i,
      iosPlatforms = /(iphone|ipad|ipod)/i;

    if (iosPlatforms.test(userAgent)) {
      setOs(OS.ios);
      return;
    }
    // else if (macosPlatforms.test(userAgent)) {
    //   setOs("macos");
    // }
    // else if (windowsPlatforms.test(userAgent)) {
    //   setOs("windows");
    // }
    else if (/android/.test(userAgent)) {
      setOs(OS.android);
      return;
    }
    // else if (!os && /linux/.test(userAgent)) {
    //   setOs("linux");
    // }
    //
    //
    setOs(OS.other);
  }, []);

  return os;
};

interface Props {
  className?: string;
}
function AppStoreButton({ className }: Props) {
  const os = useOs();

  if (os === OS.android) {
    return (
      <div className={s.container}>
        <ANDROID_LINK />
      </div>
    );
  }

  if (os === OS.ios) {
    return (
      <div className={s.container}>
        <IOS_LINK />
      </div>
    );
  }

  if (os === OS.other) {
    return (
      <div className={clsx(className, s.container)}>
        <IOS_LINK />
        <ANDROID_LINK />
      </div>
    );
  }

  return <div className={s.placeholder} />;
}

export default memo(AppStoreButton);
